import z from "zod";

import { additionalDataSchema } from "./additional-field";
import { contractSchema } from "./contract";
import {
  getOrganizationWithContactSchemaAdditionalFields,
  organizationWithContactSchema,
} from "./organization-with-contact";

export const contractWithCounterPartySchema = contractSchema.extend({
  counterParty: organizationWithContactSchema.optional(),
});

export type ContractWithCounterParty = z.infer<
  typeof contractWithCounterPartySchema
>;

export function getContractWithCounterPartySchemaAdditionalFields(additionalFields: {
  contract: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
}): typeof contractWithCounterPartySchema {
  return contractWithCounterPartySchema.extend({
    counterParty:
      getOrganizationWithContactSchemaAdditionalFields(
        additionalFields,
      ).optional(),
  });
}
